React = require 'react'
t = require('views/internal/recup-with-helpers')()
naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'

module.exports = class extends React.Component
  displayName: 'BoardListItemTagComponent'
  render: t.renderable ->
    { text, onClick, selected } = @props

    t.b onClick, class: t.classify('board-tags-item': true, 'mod-selected': selected), ->
      t.text text

  shouldComponentUpdate: naiveShouldComponentUpdate



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-item-tag-component.coffee